// extracted by mini-css-extract-plugin
export default {"component-id-tag":"SelectedInputMaterialDetail_component-id-tag__Rwq96"};